import axios from "axios";
import { deleteToken, getToken } from "./usuario";
import Swal from "sweetalert2";

//const url = "http://127.0.0.1:8000/api";
//const url = "http://192.168.100.241:8088/";
const url = "http://192.168.100.178:8010/";  
//const url = "https://atec-dev.mundopacifico.cl/api";
//const url = "https://gw-clientes.mundopacifico.cl/api";
//const url = "https://gw-clientes-pre.mundopacifico.cl:9040/"

//https://gw-clientes.mundopacifico.cl/api/pagoFacil/consultaDeudaMundo




const clienteAxios = axios.create({ baseURL: url });

clienteAxios.interceptors.request.use(
  function (config) {
    const token = getToken();
    config.headers["authorization"] = `Bearer ${token}`;
    return config;
  },
  function (error) {
    if (error.response.status === 401) {
      deleteToken();
      window.location = "/login";
    }
    return Promise.reject(error);
  }
);

clienteAxios.interceptors.response.use(
  function (response) {
    if (response.data.codigo === 401) {
      Swal.fire(
        "Error",
        "Su sesión ha expirado o ha iniciado sesión en otro equipo",
        "error"
      ).then(function () {
        deleteToken();
        window.location = "/login";
      });
    }
    return response;
  },

  function (error) {
    if (error.response.status === 401) {
      deleteToken();
      window.location = "/login";
    } else {
      return Promise.reject(error);
    }
  }
);

export default clienteAxios;
